import React from 'react';

// Wording for the three bar delivery types, kept in one place so the list, the
// detail view and the confirm screen never disagree.
export const BAR_TYPE_LABELS = {
  OUT: 'Lieferung',
  RET: 'Retoure',
  EMP: 'Leergut',
};

export const BAR_ACTUAL_LABELS = {
  OUT: 'gelieferte Menge',
  RET: 'zurückgenommene Menge',
  EMP: 'zurückgegebene Menge',
};

const BADGE_CLASS = {
  RET: 'bg-warning text-dark',
  EMP: 'bg-info text-dark',
};

const BarDeliveryTypeBadge = ({ type, cancelled = false }) => (
  <>
    {type && type !== 'OUT' && (
      <span className={`badge ms-2 ${BADGE_CLASS[type] || 'bg-secondary'}`}>
        {BAR_TYPE_LABELS[type] || type}
      </span>
    )}
    {cancelled && <span className='badge bg-danger ms-2'>storniert</span>}
  </>
);

export default BarDeliveryTypeBadge;
